import Vue from "vue";
import VueRouter from "vue-router";
import routes from 'vue-auto-routing'

Vue.use(VueRouter);

if (process.env.NODE_ENV === 'development') {
    console.log(routes)
}

/* Our Vue Router Object */
const router = new VueRouter({
    routes,
    /* Use Pretty URL */
    mode: "history",
    base: "/",
    /* Save The Scroll Position , Useful When Redirecting Back */
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    }
});

/* Middlewares */
router.beforeEach((to, from, next) => {
    /* for all authenticated routes */
    if (to.matched.some(m => m.meta.requiresAuth)) {
        /* Check For Laravel Passport Access Token Cookie */
        if (to.matched.some(m => m.meta.requiresAuth)) {
            let currentWorkstation = router.app.$store.getters['workstation/getWorkstation']
            if(currentWorkstation == null) {
                axios.get(route("api.@workstations")).then(({data}) => {
                    router.app.$store.commit('workstation/setAvailableWorkstations', data)
                }).catch(() => {
                    router.push({name: '404'})
                });
            }
            return axios.post(route("api.auth.check")).then(() => {
                return next();
            });
        }
    }
    /* If No Middleware, Then Just Proceed As Normal */
    return next();
});

export default router;
